module.exports = __webpack_public_path__ + "img/template14_mobile.b0f464e9.png";